module.exports = __webpack_public_path__ + "static/img/JPessential4.814b9e64.png";